import React, { useEffect, useState } from 'react';
import ApexCharts from 'react-apexcharts';
import '../GeneriBascula.js/graficas.css'

const GraficaGenero = ({ femenino, masculino, sinregistrar }) => {

    const femeninoNum = femenino === null ? 0 : femenino;
    const masculinoNum = masculino === null ? 0 : masculino;
    const sinregistrarNum = sinregistrar === null ? 0 : sinregistrar;
    const total = femeninoNum + masculinoNum + sinregistrarNum;
    const [labelsAndColors, setLabelsAndColors] = useState([]);


    useEffect(() => {
        // Actualiza las etiquetas y los colores de la serie
        setLabelsAndColors([
            { label: 'Femenino', color: '#1983c4' },
            { label: 'Masculino', color: '#79385f' },
            { label: 'Sin registrar', color: 'gray' },
        ]);
    }, []);

    const seriesData = [femeninoNum, masculinoNum, sinregistrarNum];
    const options = {
        series: seriesData,
        chart: {
            type: 'donut',
            height: 250,
            width: 500,
        },
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 90,
                donut: {
                    size: '50%',
                },
                customScale: 0.8,
                spacing: 20, // Ajusta este valor para cambiar el espacio entre las series
            },
        },
        grid: {
            padding: {
                bottom: -80,
            },
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
        colors: ['#1983c4', '#79385f', 'gray'],
        labels: ['Femenino', 'Masculino', 'Sin registrar'],

        legend: {
            offsetY: 70,
            offsetX: 20, // Ajusta este valor para mover las leyendas más abajo
            formatter: function (seriesName, opts) {
                // Agrega el número correspondiente a la serie
                const seriesIndex = opts.seriesIndex;
                return `${seriesName} - ${options.series[seriesIndex]}`;
            },
        },
        dataLabels: {
            style: {
                fontSize: '18px', // Ajusta el tamaño de la fuente
                fontFamily: "'Segoe UI Variable Static Small 600', sans-serif", // Cambia la fuente
                fontWeight: 200,
            },
        },
        stroke: {
            width: 10
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: function (value, { seriesIndex }) {
                    if (labelsAndColors[seriesIndex]) {
                        const label = labelsAndColors[seriesIndex].label || 'Desconocido';
                        const color = labelsAndColors[seriesIndex].color || 'black';
                        const value = seriesData[seriesIndex];
                        return (
                            '<div className="custom-tooltip" style="width: 50px; font-size: 12px; border-radius: 10%; text-align: center;">' +
                            '<div className="tooltip-label" style="background-color: ' +
                            color +
                            '; color: white; margin-left:-100%">' +
                            label +
                            '</div>' +
                            '<div className="tooltip-content" style="display: flex; align-items: center; background-color:#dadde9; height: 25px; padding: 5px 10px; background-color:white;width:300px;margin-left:-175%">' +
                            '<div className="sales-circle" style="background-color: ' +
                            color +
                            '; border-radius: 50%; width: 10px; height: 10px;"></div>' +
                            '<div className="sales-value" style="font-weight: bold; margin-left:5%; color: black">' +
                            value + // Mostrar el valor como porcentaje
                            '</div>' +
                            '</div>' +
                            '</div>'
                        );
                    }


                },
            },
        },
    };



    return (
        <div id="grafica-genero">
            <ApexCharts options={options} series={options.series} type="donut" height={250} width={500} />
            <div className={total === 0 ? "total-value0" : "total-value"}>{total}</div>
            <div className={total === 0 ? "total-genero0" : "total-genero"}>Total</div>

        </div>
    );
};

export default GraficaGenero;